// extracted by mini-css-extract-plugin
export var carrierIcon = "_wv-0";
export var carrierLogo = "_wv-1";
export var detailsSection = "_wv-2";